import { OrderAttemptDto } from "./OrderAttempt"
import { REMOVE_ORDER_ATTEMPT, UPDATE_ORDER_ATTEMPT_LIST } from "./orderAttemptActionTypes"


export type OrderAttemptStore = {
    OrderAttempts: OrderAttemptDto[]
}

const defaultState: OrderAttemptStore = {
    OrderAttempts: []
}

function orderAttemptReducer(state = defaultState, action) {
    switch(action.type) {
    case UPDATE_ORDER_ATTEMPT_LIST:
        state.OrderAttempts = action.payload.orderAttempts
        return {...state}
    case REMOVE_ORDER_ATTEMPT:
        const id = action.payload.orderAttemptId
        state.OrderAttempts = state.OrderAttempts.filter(o => o.id != id)
        return {...state}
    default:
        return state
    }
}

export default orderAttemptReducer


// WEBPACK FOOTER //
// ./src/state/price-list/orderAttemptReducer.ts